import { SVGProps } from 'react';
const SvgArrowUpSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 17V7M8 11l4-4 4 4"
    />
  </svg>
);
export default SvgArrowUpSm;
